import { useState } from 'react'
import { buildCityPack, fetchPOI } from '@services/api'
import { savePOIContent, putPOIs, setSetting } from '@services/indexeddb'

export default function CityPackDownload({ lang }: { lang: string }) {
  const [open, setOpen] = useState(false)
  const [city, setCity] = useState('Cape Town')
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState('')
  return (
    <div className="relative">
      {!open ? (
        <button className="flex items-center gap-2 px-4 py-2 bg-secondary-container text-on-secondary-container rounded-xl hover:bg-secondary-fixed transition-all font-medium" onClick={() => setOpen(true)}>
          <span className="material-symbols-outlined">download_for_offline</span>
          <span className="text-sm hidden md:inline">City Pack</span>
        </button>
      ) : (
        <div className="absolute top-14 right-0 bg-surface-container-lowest p-5 rounded-2xl shadow-2xl border border-outline-variant/20 flex flex-col gap-4 z-50 w-80">
          <h3 className="text-sm font-bold text-on-surface uppercase tracking-wider">Offline Pack</h3>
          <input className="w-full text-sm p-3 rounded-xl bg-surface-container border border-outline-variant/50 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" value={city} onChange={e => setCity(e.target.value)} placeholder="City Name" />
          <div className="flex gap-3 mt-2">
            <button className="flex-1 bg-primary text-white py-3 rounded-xl text-sm font-bold shadow-md hover:bg-primary/90 disabled:opacity-50 transition-all" disabled={busy} onClick={async () => {
              setBusy(true)
              setMsg('')
              try {
                const manifest = await buildCityPack(city, lang)
                await putPOIs(manifest.items)
                let count = 0
                for (const it of manifest.items) {
                  if (it.id) {
                    const d = await fetchPOI(it.id, lang)
                    await savePOIContent(it.id, lang, d)
                    count++
                  }
                }
                await setSetting(`download:${city}`, { city, lang, ts: Date.now() })
                setMsg(`Downloaded ${count} items.`)
                setTimeout(() => setOpen(false), 2000)
              } catch (e: any) {
                setMsg(`Failed: ${e?.message || 'error'}`)
              } finally {
                setBusy(false)
              }
            }}>Build</button>
            <button className="flex-1 border-2 border-outline-variant/50 text-on-surface py-3 rounded-xl text-sm font-bold hover:bg-surface-container transition-all" onClick={() => setOpen(false)} disabled={busy}>Cancel</button>
          </div>
          {msg && <p className="text-xs font-medium text-tertiary mt-1 text-center bg-error-container/30 py-2 rounded-lg">{msg}</p>}
        </div>
      )}
    </div>
  )
}
